'use strict';

/* jshint -W098 */
angular.module('mean.projects').controller('ProjectHomeController', ['$scope', '$rootScope', 'Global', 'MeanUser', 'Users', '$filter', 'Projects', 'ProjectTasks', '$timeout', 'ProjectBids', 'Builders',
  function($scope, $rootScope, Global, MeanUser, Users, $filter, Projects, ProjectTasks, $timeout, ProjectBids, Builders) {
    $scope.global = Global;

    $scope.package = {
      name: 'projectHome'
    };

    $scope.spreadsheets = [];
    $scope.spreadsheets.phases = [];
    $scope.spreadsheets.phases.lots = [];
    $scope.spreadsheets.phases.lots.data = [];

    //$scope.colors = ['#FD1F5E','#1EF9A1','#7FFD1F','#68F000'];

    $scope.bid_hours_labels = ["Total Hours", "Not Complete", "Delayed", "Completed", "No Valid Project or Tasks"];
  	$scope.bid_hours_data = [];
  	$scope.line_chart_labels = ["January", "February", "March", "April", "May", "June", "July"];
  	$scope.line_chart_series = ['Bid Hours', 'Actual Hours'];
  	$scope.line_chart_data = [
    	[65, 59, 80, 81, 56, 55, 40],
    	[28, 48, 40, 19, 86, 27, 90]
  	];

  	$scope.onClick = function (points, evt) {
    	console.log(points, evt);
  	};

  	$scope.graphs = ['Labor Hours', 'Labor Costs', 'Materials'];
  	$scope.selectedGraph = 'Labor Hours';
  	$scope.selectedItem = {};
    $scope.tasks = [];
    $scope.builders = [];
    $scope.projects = [];
    $scope.phases = [];

    $scope.user = MeanUser.user;
    $scope.wait = true;

    $rootScope.$on('loggedin', function() {
        $scope.user = MeanUser.user;
        $scope.init();
    });

    $scope.phaseFilter = function(selected) {
    	if(!selected) return;

    	if(selected.name === 'All') {
    		return function() { 
    			return true;
    		};
    	} else {
    		return function(selectedPhase) {
	    		return selectedPhase.name === selected.name;
	    	};
    	}
    };

    $scope.changePhase = function() {
    	if(!$scope.selectedPhase) return;

    	if($scope.selectedPhase.name === 'All') {
	    	var my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.user.trade[0]});
	    } else {
	    	var my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.user.trade[0], 'phase': $scope.selectedPhase.name});
	    }

    	var total_hours_allowed = 0;
		var completed_hours = 0;
		var not_completed_hours = 0;
		var delayed_hours = 0;

		my_tasks.forEach(function(task) {
			var bid = $filter('filter')($scope.bid_tasks, {'task_name': task.task_name, 'plan_code': task.plan_code});

			if(bid.length === 1) {
    			total_hours_allowed += bid[0].totals.hours_allowed;
				if(task.status === 'finished') {
					completed_hours += bid[0].totals.hours_allowed;
				} else if(task.status === 'on_track'){
					not_completed_hours += bid[0].totals.hours_allowed;
				} else {
					delayed_hours += bid[0].totals.hours_allowed;
				}
			} else if(bid.length > 1){
				alert('too many bids coming back');
			}

		});

		$scope.bid_hours_data = [total_hours_allowed, not_completed_hours, delayed_hours, completed_hours, 0];
    };

    $scope.changeBuilder = function() {
    	if(!$scope.selectedBuilder) return;
    	$scope.projects = [];
		$scope.tasks = [];
		$scope.phases = [];
		$scope.bid_tasks = [];
		$scope.bid_hours_data = [0,0,0,0,1];

    	Projects.query({'builder.name': $scope.selectedBuilder.name, 'trades.manager.username': MeanUser.user.username}, function(projects) {
    		$scope.projects = projects;
    		$scope.selectedItem = projects[0];
    		if($scope.selectedItem) {
    			$scope.changeProject();
    		}
    	});
    };

    $scope.buildSpreadsheet = function() {
    	$scope.spreadsheets = [];
	    $scope.spreadsheets.phases = [];
	    $scope.spreadsheets.phases.lots = [];

    	var my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.user.trade[0]});
    	var phase_tasks = [];
    	var lot_tasks = [];
    	var ordered_tasks = [];
    	var temp_tasks = [];
    	var lot_numbers = [];
    	var lot_data = [];

    	$scope.phases.forEach(function(phase) {
    		if(phase.name !== 'All') {
    			//get all of my tasks by the current phase
    			phase_tasks = $filter('filter')(my_tasks, {'phase': phase.name});

    			lot_numbers = [];
    			//build a lot list
    			phase_tasks.forEach(function(task) {
	    			var in_var = $filter('filter')(lot_numbers, {'name': task.lot});
	    			temp_tasks = [];

	    			if(in_var.length === 0) {
	    				lot_numbers.push({
	    					name: task.lot
	    				});
	    			}
	    		});

	    		lot_numbers = $filter('orderBy')(lot_numbers, ['name'], false);

    			lot_numbers.forEach(function(lot_number) {
    				lot_data = [];
    				var total_hours_allowed = 0;
    				var total_labor_costs = 0;
    				var actual_man_hours = 0;
    				var actual_labor_costs = 0;
    				var total_hours_saved = 0;
    				var total_labor_saved = 0;

    				lot_tasks = $filter('filter')(phase_tasks, {'lot': lot_number.name});
    				ordered_tasks = $filter('orderBy')(lot_tasks, ['job_code'], false);

    				ordered_tasks.forEach(function(task) {
	    				var bid = $filter('filter')($scope.bid_tasks, {'plan_code': task.plan_code, 'task_code': task.task_code});
						if(bid.length === 0) {
							var new_bid = {
								totals: {
									hours_allowed: 0,
									labor_cost: 0
								}
							}

							bid.push(new_bid);

						} else if(bid.length > 1) {
							alert('more than one bid back when getting the spreadsheets' + bid.length);
						}

			    		var code = task.contractor_code + '-' +
			    					task.division_code + '-' +
			    					task.job_code + '-' +
			    					task.phase + '-' +
			    					task.lot + '-' +
			    					task.task_code;

			    		var hours_saved = 0;
			    		var labor_saved = 0;

			    		total_hours_allowed += bid[0].totals.hours_allowed;
			    		total_labor_costs += bid[0].totals.labor;
			    		actual_man_hours += task.actual_man_hours;
			    		actual_labor_costs += task.actual_labor_costs;
			    		hours_saved = bid[0].totals.hours_allowed - task.actual_man_hours;
			    		labor_saved = bid[0].totals.labor - task.actual_labor_costs;
			    		total_hours_saved += hours_saved;
			    		total_labor_saved += labor_saved;

			    		lot_data.push({
		    				lot: task.lot,
				    		code: code,
				    		hours_allowed: bid[0].totals.hours_allowed,
				    		labor_cost: bid[0].totals.labor,
				    		scheduled_date: new Date(task.start_date),
				    		actual_man_hours: task.actual_man_hours,
				    		actual_labor_costs: task.actual_labor_costs,
				    		saved_man_hours: hours_saved,
				    		saved_labor_costs: labor_saved
			    		});
	    			});

					temp_tasks.push({
						name: lot_number.name,
						data: lot_data,
						total_hours_allowed: total_hours_allowed,
	    				total_labor_costs: total_labor_costs,
	    				actual_man_hours: actual_man_hours,
	    				actual_labor_costs: actual_labor_costs,
	    				total_hours_saved: total_hours_saved,
	    				total_labor_saved: total_labor_saved
					});
    			});

				$scope.spreadsheets.phases.push({
		    		name: phase.name,
		    		lots: temp_tasks
		    	});
    		}
    	});

		console.log('finished task build' + $scope.spreadsheets);
    };

    $scope.changeProject = function() {
    	if(!$scope.selectedItem) return;

    	ProjectTasks.query({'project_id': $scope.selectedItem._id}, function (tasks) {
    		$scope.tasks = [];
    		$scope.tasks = tasks;
    		var my_tasks = $filter('filter')(tasks, {'trade': $scope.user.trade[0]});

    		$scope.phases = [];

    		tasks.forEach(function(task) {
    			var in_var = $filter('filter')($scope.phases, { 'name': task.phase});

    			if(in_var.length === 0) {
    				$scope.phases.push({
    					name: task.phase
    				});
    			}
    		});

    		$scope.phases = $filter('orderBy')($scope.phases, ['name'], false);

    		$scope.phases.unshift({
    			name: 'All'
    		});

    		$scope.selectedPhase = $scope.phases[0];
    			
			var total_hours_allowed = 0;
    		var completed_hours = 0;
    		var not_completed_hours = 0;
    		var delayed_hours = 0;

    		ProjectBids.query({'project_id': $scope.selectedItem._id, 
                'trade': $scope.user.trade[0]}, function(bid_tasks) {
    			$scope.bid_tasks = bid_tasks;

	    		my_tasks.forEach(function(task) {
	    			var bid = $filter('filter')($scope.bid_tasks, {'task_name': task.task_name, 'plan_code': task.plan_code});

	    			if(bid.length === 1) {
		    			total_hours_allowed += bid[0].totals.hours_allowed;
	    				if(task.status === 'finished') {
	    					completed_hours += bid[0].totals.hours_allowed;
	    				} else if(task.status === 'on_track'){
	    					not_completed_hours += bid[0].totals.hours_allowed;
	    				} else {
	    					delayed_hours += bid[0].totals.hours_allowed;
	    				}
	    			} else if(bid.length > 1){
	    				alert('too many bids coming back');
	    			}

	    		});

    			$scope.bid_hours_data = [total_hours_allowed, not_completed_hours, delayed_hours, completed_hours, 0];
    			$scope.buildSpreadsheet();
    		});
    	});
    };

    $scope.init = function() {
    	if(!MeanUser.user.username) return;

    	$scope.bid_hours_data = [0,0,0,0,1];

    	Builders.query({}, function(builders) {
    		$scope.builders = builders;
    		$scope.selectedBuilder = builders[0];

		    Projects.query({'builder.name': $scope.selectedBuilder.name, 'trades.manager.username': MeanUser.user.username}, function(projects) {
		    	$scope.projects = projects;
		    	$scope.selectedItem = projects[0];

		    	if(!$scope.selectedItem) return;

		    	ProjectTasks.query({'project_id': projects[0]._id}, function (tasks) {
		    		$scope.tasks = tasks;
		    		var my_tasks = $filter('filter')(tasks, {'trade': $scope.user.trade[0]});

		    		tasks.forEach(function(task) {
		    			var in_var = $filter('filter')($scope.phases, { 'name': task.phase});

		    			if(in_var.length === 0) {
		    				$scope.phases.push({
		    					name: task.phase
		    				});
		    			}
		    		});

		    		$scope.phases = $filter('orderBy')($scope.phases, ['name'], false);

		    		$scope.phases.unshift({
		    			name: 'All'
		    		});

		    		$scope.selectedPhase = $scope.phases[0];
		    		var total_hours_allowed = 0;
		    		var completed_hours = 0;
		    		var not_completed_hours = 0;
		    		var delayed_hours = 0;

		    		ProjectBids.query({'project_id': $scope.selectedItem._id, 
                        'trade': $scope.user.trade[0]}, function(bid_tasks) {
		    			$scope.bid_tasks = bid_tasks;

			    		my_tasks.forEach(function(task) {
			    			var bid = $filter('filter')($scope.bid_tasks, {'task_name': task.task_name, 'plan_code': task.plan_code});

			    			if(bid.length === 1) {
				    			total_hours_allowed += bid[0].totals.hours_allowed;
			    				if(task.status === 'finished') {
			    					completed_hours += bid[0].totals.hours_allowed;
			    				} else if(task.status === 'on_track'){
			    					not_completed_hours += bid[0].totals.hours_allowed;
			    				} else {
			    					delayed_hours += bid[0].totals.hours_allowed;
			    				}
			    			} else if(bid.length > 1){
			    				alert('too many bids coming back');
			    			}

			    		});

		    			$scope.bid_hours_data = [total_hours_allowed, not_completed_hours, delayed_hours, completed_hours, 0];
		    			$scope.buildSpreadsheet();
		    		});
		    	});
		    });
		});
	};
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectHome.js